module.exports = __webpack_public_path__ + "img/framenew_box21.bacb88b6.jpg";